import './index.css';

import Amplify from 'aws-amplify';
import React from 'react';
import { ContentfulClient, ContentfulProvider } from 'react-contentful';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';

import App from './App';
import awsconfig from './config/aws-exports.js';
import contentfulConfig from './config/contentful';
import gtmConfig from './config/gtm';
import ThemeProvider from './theme/ThemeProvider';
import { applyMetaInformation } from './utils/metaInformationUtils';

// eslint-disable-next-line no-console
console.log('Optimise WebApp Version: ', process.env.REACT_APP_VERSION);

const contentfulClient = new ContentfulClient(contentfulConfig);

Amplify.configure({
  Auth: {
    region: awsconfig.aws_project_region,
    userPoolId: awsconfig.aws_user_pools_id,
    userPoolWebClientId: awsconfig.aws_user_pools_web_client_id,
    oauth: {
      domain: 'lo-preview.auth.eu-west-1.amazoncognito.com', // replace with your Cognito domain
      scope: ['email', 'openid'],
      redirectSignIn: 'http://localhost:3000/sign-in', // replace with your redirect URL
      redirectSignOut: 'http://localhost:3000/sign-out', // replace with your signout URL
      responseType: 'code',
    },
  },
});

TagManager.initialize({ gtmId: gtmConfig.id });

applyMetaInformation();

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container missing in index.html');
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    {/* 
      ThemeProvider works by:
      1. Loading the appropriate theme from src/theme/themes/ based on the aws-exports config file
      2. Providing theme values (colors, typography, spacing, etc.) to all child components
      3. Applying global styles with CSS variables
      
      The theme is determined by the useThemeConfig hook which checks the config file
      in ThemeConfigLoader.tsx. The default is the Loop theme
    */}
    <ThemeProvider>
      <ContentfulProvider client={contentfulClient} locale="en-GB">
        <App />
      </ContentfulProvider>
    </ThemeProvider>
  </React.StrictMode>
);
